import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Maplewood",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Maplewood Minnesota cityscape with suburban neighborhoods along Interstate 94, Maplewood Mall area, east metro Twin Cities landscape, residential streets with mature trees, near St. Paul skyline in distance, warm golden hour lighting, professional cityscape photography, no readable text or signs",
  heroImageSeq: "maplewood-mn-hero-2026",
  heroDescription:
    "Business trip to Europe in two weeks? Family vacation to Mexico and your passport just expired? Need a first-time passport for a new job? We help Maplewood residents — from east metro commuters to Ramsey County families and St. Paul-area professionals — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.9530; -92.9952",
  geoPlacename: "Maplewood, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/maplewood/",
  localAreaTitle: "Serving Maplewood & East Metro Ramsey County",
  localAreaText: [
    "Maplewood, Minnesota is a thriving east metro suburb located just minutes from downtown St. Paul. As one of the closest suburbs to the Minnesota State Capitol, the city has a unique position that attracts state government employees, healthcare professionals, and business commuters. The city's proximity to I-94 and Highway 61 makes it an ideal location for professionals who need quick access to both St. Paul and Minneapolis.",
    "The Maplewood Mall area and the commercial corridors along White Bear Avenue have developed into major retail and business centers, creating a prosperous community where international travel is common. Maplewood residents work in a variety of industries — healthcare at the nearby St. Joseph's Hospital, retail, manufacturing, and professional services — and many travel for business, conferences, and client meetings.",
    "Maplewood's location in Ramsey County places it at the heart of the east metro community. The city's proximity to St. Paul, Oakdale, White Bear Lake, and Woodbury creates a regional network where residents travel together for group trips, sports tournaments, and family vacations. The area's strong school system and youth sports programs also generate travel for competitions and tournaments.",
    "The residential neighborhoods of Maplewood are diverse, from established communities near the golf course to newer developments in the city's north and east. The Maplewood Community Center and the city's parks and recreation programs create a family-friendly environment where international travel is a natural part of the lifestyle. Many residents are first-generation Americans who maintain strong connections to their heritage countries.",
  ],
  nearbyCities: [
    { name: "Maplewood", zips: "55109, 55117" },
    { name: "St. Paul", zips: "55101–55119" },
    { name: "Oakdale", zips: "55128" },
    { name: "White Bear Lake", zips: "55110" },
    { name: "Woodbury", zips: "55125, 55129" },
    { name: "Roseville", zips: "55112, 55113" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from Maplewood to send your documents directly to us.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Maplewood & East Metro Coverage",
  serviceAreaDescription: "Serving Ramsey County and east metro communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Maplewood, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Maplewood can take 2–6 months. For families with vacation plans and professionals with business trips, that timeline is not viable.",
    },
    {
      q: "Can families get expedited passports before a vacation?",
      a: "Absolutely. Maplewood families are one of our most common client types. Many families book trips and discover passport issues close to departure. We regularly process expedited renewals and child passports for families on compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "What if my passport expires before a business trip?",
      a: "Maplewood professionals frequently travel for business with short notice. If your passport is expiring or expired, we can expedite your renewal so you do not miss critical meetings. Most business trips are scheduled 2–3 weeks out.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Maplewood travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Maplewood. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the east metro.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "Robert K.",
      location: "Maplewood, MN",
      rating: 5,
      text: "I commute to St. Paul and received a last-minute assignment to a client meeting in London with ten days notice. My passport was within two months of expiration. Fast Passport Center processed my renewal in four business days. I made the meeting and it went perfectly. Their document review was thorough.",
      service: "Passport Renewal",
    },
    {
      name: "The Martinez Family",
      location: "Maplewood, MN",
      rating: 5,
      text: "We planned a family trip to Mexico and discovered our daughter's passport had expired two weeks before departure. Fast Passport Center processed her child passport in five business days. We made our trip and created wonderful memories. Thank you for the professional service.",
      service: "Child Passport",
    },
    {
      name: "Angela T.",
      location: "Maplewood, MN",
      rating: 5,
      text: "I was invited to a conference in Berlin with three weeks notice. My passport was within two months of expiration. Fast Passport Center had my renewal processed in five business days. I attended the conference and made valuable connections. Exceptional service.",
      service: "Emergency Renewal",
    },
  ],
  nearbyLinks: [
    { name: "St. Paul", href: "/st-paul" },
    { name: "Woodbury", href: "/woodbury" },
    { name: "Oakdale", href: "/minnesota" },
    { name: "Roseville", href: "/minnesota" },
    { name: "White Bear Lake", href: "/minnesota" },
    { name: "Minneapolis", href: "/minneapolis" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Maplewood",
  introDescription: "Fast, reliable passport processing for Maplewood and east metro Ramsey County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Maplewood and east metro resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Maplewood Post Office",
      address: "2550 E 7th St, Maplewood, MN 55119",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(651) 773-3575",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Maplewood and Ramsey County.",
    },
    {
      name: "St. Paul Main Post Office",
      address: "180 E Kellogg Blvd, St. Paul, MN 55101",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 292-3821",
      notes: "Convenient for St. Paul and east metro residents. Full passport services. Photo services available. Call ahead for appointment.",
    },
    {
      name: "Woodbury Post Office",
      address: "7205 Lake Rd, Woodbury, MN 55125",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 731-1920",
      notes: "Serves Woodbury and Washington County residents. Call ahead for appointment availability.",
    },
    {
      name: "Roseville Post Office",
      address: "2757 W County Line Rd, Roseville, MN 55113",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 636-7580",
      notes: "Serves Roseville and Ramsey County residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Maplewood", address: "2985 White Bear Ave, Maplewood, MN 55110", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Maplewood", address: "1745 Beam Ave, Maplewood, MN 55109", hours: "Call for hours" },
    { name: "The UPS Store — Maplewood", address: "1905 County Road D E, Maplewood, MN 55109", hours: "Call for hours" },
    { name: "Walgreens — St. Paul", address: "1015 Rice St, St. Paul, MN 55117", hours: "Call for hours" },
    { name: "CVS Pharmacy — Woodbury", address: "10040 City Walk Dr, Woodbury, MN 55129", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — St. Paul", address: "50 W 5th St, St. Paul, MN 55102", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Maplewood",
      address: "Maplewood area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Ramsey County Service Center",
      address: "St. Paul, MN 55101",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Ramsey County services. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 15 miles from Maplewood — 20 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for Maplewood residents. Direct international flights to Europe, Asia, and Latin America. The east metro location provides excellent access via I-94 or Highway 5.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "Rochester, MN — about 90 miles south",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Secondary option for southern Minnesota travelers. Seasonal international charters and domestic connections.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSP Airport Proximity",
      subtitle: "Only 20 minutes from Maplewood — excellent access for international travel",
      content:
        "Maplewood's location in the east metro provides excellent access to MSP Airport via I-94 or Highway 5. This proximity is a major advantage for the area's frequent international travelers. With nonstop service to Amsterdam, London, Paris, Tokyo, and Reykjavik, many residents connect directly to Europe and Asia.",
      tip: "Check your passport expiration before booking MSP international connections. Most countries require six months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "East Metro Family Travel",
      subtitle: "Active families with travel plans throughout the year",
      content:
        "Maplewood families are among the most active travelers in the east metro. Spring break trips, summer vacations, and holiday visits to relatives abroad are all common. The area's proximity to MSP makes international travel particularly convenient for families.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10. Plan renewals 6 months before any planned travel.",
      icon: "ri-parent-line",
    },
    {
      title: "St. Paul Commuter Travel",
      subtitle: "Professionals commuting to the capital city with international clients",
      content:
        "Maplewood's proximity to St. Paul means many residents work in state government, healthcare, and professional services with international connections. These professionals often receive travel assignments with 2–3 weeks notice: a client meeting in London, a project review in Frankfurt, a training session in Singapore.",
      tip: "Commuter professionals should check passport expiration quarterly. Set calendar reminders. Business travel often has unpredictable lead times.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Heritage & Cultural Travel",
      subtitle: "First-generation families maintaining connections to their home countries",
      content:
        "Maplewood is home to many first-generation Americans who maintain strong connections to their heritage countries. These families travel regularly for family visits, cultural events, and religious observances. Their travel is often planned around family schedules and cultural calendars.",
      tip: "Heritage travelers should keep passports current at all times. Family visits are often planned on short notice due to changing circumstances. Check expiration dates at least 6 months before any anticipated travel.",
      icon: "ri-earth-line",
    },
  ],
  destinations: [
    {
      name: "Mexico",
      context: "Cancun, Puerto Vallarta, and Cabo for spring break and family vacations",
      urgency: "Spring break trips and resort packages are often booked 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises, all-inclusive resorts, and island hopping",
      urgency: "Cruise departures and resort packages are often booked 3–6 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London business meetings and conferences",
      urgency: "Business and conference schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Frankfurt, Munich, and Berlin for business and conferences",
      urgency: "Conference and event schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Philippines",
      context: "Family visits and heritage travel for the area's Filipino community",
      urgency: "Family visits are often planned 2–4 weeks out due to changing schedules",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "India",
      context: "Family visits, cultural events, and religious observances",
      urgency: "Family visits are often planned around cultural calendars and short notice",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "45%",
      label: "of Maplewood expedited requests are family or heritage travel discovered within 3 weeks of departure",
    },
    {
      stat: "2–4 Weeks",
      label: "average notice Maplewood travelers have before a planned international trip",
    },
    {
      stat: "Mar–Aug",
      label: "peak season when spring break, summer vacations, and cultural travel coincide",
    },
    {
      stat: "48 Hours",
      label: "shortest emergency turnaround we have accommodated for a Maplewood professional",
    },
  ],
};

export default function MaplewoodPage() {
  return <CityPage data={data} />;
}